import React from "react";
import type { ConceptBrief } from "../concept/ConceptType";
import {
  extractMentionedConcepts,
  renderViewpointConceptLinkedText,
} from "./ViewpointConceptUtil";

export function ViewpointConceptLinkedBody(props: {
  content: string;
  catalog: ConceptBrief[];
  onConceptClick: (concept: ConceptBrief) => void;
  importancePrefix?: React.ReactNode;
  hotBadge?: React.ReactNode;
}): JSX.Element {
  const { content, catalog, onConceptClick, importancePrefix, hotBadge } = props;
  const linked = renderViewpointConceptLinkedText(content, catalog, onConceptClick);
  return (
    <div className="lf-vp-moment-body">
      {importancePrefix}
      {hotBadge}
      {linked}
    </div>
  );
}

export function ViewpointConceptTagRow(props: {
  content: string;
  catalog: ConceptBrief[];
  onConceptClick: (concept: ConceptBrief) => void;
}): JSX.Element | null {
  const { content, catalog, onConceptClick } = props;
  const mentioned = extractMentionedConcepts(content, catalog);
  if (mentioned.length === 0) {
    return null;
  }
  return (
    <div className="lf-vp-moment-concept-row" aria-label="提及的概念">
      <div className="lf-vp-moment-concept-tags">
        {mentioned.map((c) => (
          <button
            key={c.code}
            type="button"
            className="lf-vp-moment-concept-tag"
            onClick={(e) => {
              e.stopPropagation();
              onConceptClick(c);
            }}
          >
            {c.name.trim()}
          </button>
        ))}
      </div>
    </div>
  );
}
